export default function uuid() {
  return (String([1e7]) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/gu, ch =>
    (
      Number(ch) ^
      (window.crypto.getRandomValues(new Uint8Array(1))[0] &
        (15 >> (Number(ch) / 4)))
    ).toString(16)
  );
}
